/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat =
  ClosedEnum<typeof GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat>;

export type GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
};

/** @internal */
export const GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat
  > = z.nativeEnum(GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat);

/** @internal */
export const GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat
  > = GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$ {
  /** @deprecated use `GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format:
      GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$inboundSchema
        .default("json"),
    start: z.nullable(z.number()).default(null),
  });

/** @internal */
export type GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$Outbound =
  {
    end: number | null;
    format: string;
    start: number | null;
  };

/** @internal */
export const GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format:
      GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearFormat$outboundSchema
        .default("json"),
    start: z.nullable(z.number()).default(null),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$ {
  /** @deprecated use `GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$Outbound;
}

export function getApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequestToJSON(
  getApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest:
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$outboundSchema
      .parse(getApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest),
  );
}

export function getApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest' from JSON`,
  );
}
